module.exports = __webpack_public_path__ + "static/media/logo.c5a10fb9.png";